module.exports = __webpack_public_path__ + "img/odd-number-triangle-start-highlight.f1d15e0a.png";